import { SUPPORT_TICKET_LABEL, SUPPORT_TICKET_URL } from '@/constants/support';
import type { NotificationActionButton, NotificationType } from '@/types/notification.types';

export function withErrorSupportAction(type: NotificationType, actions: NotificationActionButton[] = []): NotificationActionButton[] {
  if (type !== 'error' && type !== 'dropped') return actions;
  if (actions.some(({ href }) => href === SUPPORT_TICKET_URL)) return actions;
  return [...actions, { label: SUPPORT_TICKET_LABEL, href: SUPPORT_TICKET_URL, variant: 'secondary', trailingIcon: 'externalLink' }];
}
